import Vue from 'vue';

import Vuetify from 'vuetifyFramework';

import {VApp} from 'vuetifyComponents/VApp';
import {VNavigationDrawer} from 'vuetifyComponents/VNavigationDrawer';
import {VAppBar} from 'vuetifyComponents/VAppBar';
import {VContainer, VSpacer} from 'vuetifyComponents/VGrid';
import {VMain} from 'vuetifyComponents/VMain';
import {VDialog} from 'vuetifyComponents/VDialog';
import {VBtn} from 'vuetifyComponents/VBtn';
import {VFooter} from 'vuetifyComponents/VFooter';
import {VSelect} from 'vuetifyComponents/VSelect';
import {VIcon} from 'vuetifyComponents/VIcon';
import {VAppBarNavIcon} from 'vuetifyComponents/VAppBar';
import {VForm} from 'vuetifyComponents/VForm';
import {VTextField} from 'vuetifyComponents/VTextField';
import {VList, VListItem} from 'vuetifyComponents/VList';
import { VCard, VCardActions, VCardText, VCardTitle } from 'vuetifyComponents/VCard';
import {appThemeDark} from "../../config/app";

Vue.use(Vuetify, {
    components: { VApp, VNavigationDrawer, VAppBar, VContainer, VMain, VDialog, VBtn, VFooter, VSelect, VIcon, VAppBarNavIcon, VCard, VCardActions, VCardText, VCardTitle, VForm, VTextField, VSpacer, VList, VListItem},
});

export function createVuetify() {
    let preset = {
        icons: {
            iconfont: 'mdiSvg',
        },
        theme: {
            themes: {
                dark: {},
            },
            dark: appThemeDark,
        },
        rtl: false,
    };

    return new Vuetify(preset);
}
